"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var DESCRIPTIONS = [
    "Too Short",
    "Weak",
    "So-So",
    "Good",
    "Strong"
];
var classFactory = function (theme, className, isChecking, score) {
    var _a;
    if (isChecking) {
        return classnames_1.default(theme.strength, className);
    }
    return classnames_1.default(theme.strength, className, (_a = {},
        _a[theme["very-weak"]] = score === 0,
        _a[theme.weak] = score === 1,
        _a[theme.normal] = score === 2,
        _a[theme.strong] = score === 3,
        _a[theme["very-strong"]] = score === 4,
        _a));
};
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, score = _a.score, isChecking = _a.isChecking, others = tslib_1.__rest(_a, ["theme", "className", "score", "isChecking"]);
    return ((!isChecking && score < 0)
        ? null
        : React.createElement("div", tslib_1.__assign({}, others, { title: isChecking ? "Checking... " : DESCRIPTIONS[score], className: classFactory(theme, className, isChecking, score) }),
            React.createElement("div", { className: theme.bars },
                React.createElement("div", { className: theme.bar }),
                React.createElement("div", { className: theme.bar }),
                React.createElement("div", { className: theme.bar }),
                React.createElement("div", { className: theme.bar }))));
});
